import { useNotificationConfirm, useNotificationList } from 'api/common/notification-fetch'
import { Line, SplitBar, StatusList, Text } from 'components'
import { queryClient } from 'index'
import { useEffect, useState } from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { sideMenuState } from 'store/atom/app-state-atom'
import { userInfoState } from 'store/atom/user-state-atom'
// css
import 'assets/style/common.scss'
import useModal from 'hook/useModal'
import { useNavigate } from 'react-router-dom'

export default function Notification() {
  const userInfo = useRecoilValue(userInfoState)
  const setSideMenuState = useSetRecoilState(sideMenuState)
  const navigate = useNavigate()

  const { alertModal, openMenuRecip, openCarte, openIngredients, closeModal } = useModal()
  const [isInit, setIsInit] = useState(false)
  const [list, setList] = useState([])
  const { data, refetch } = useNotificationList({ recrId: userInfo.userId }, isInit)
  const notificationConfirm = useNotificationConfirm({
    successHandler: (data) => {
      refetch()
    },
    errorHandler: () => {},
  })

  useEffect(() => {
    setIsInit(true)
    return () => {
      queryClient.removeQueries('notificationList')
    }
  }, [])

  useEffect(() => {
    if (data) {
      //console.log(groupByKey(data, 'regDt'))
      let temp = groupByKey(data, 'regDt')
      Object.keys(temp).map((key) =>
        temp[key].map((item) => {
          item.id = item.ntcnHstrySerno
          item.status = { title: item.ttlDvsnNm, color: 'outline' }
          item.title = item.cn
          item.username = item.regrNm ? `${item.regrNm} [${item.regDpt}]` : ''
          return item
        }),
      )
      setList(temp)
    }
  }, [data])

  const groupByKey = (array, key) => {
    return array.reduce((hash, obj) => {
      if (obj[key] === undefined) return hash
      return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
    }, {})
  }

  const confirm = (data) => {
    let result = {}
    Object.entries(data).forEach(([key, value]) => {
      if (['ntcnHstrySerno', 'recrId'].indexOf(key) > -1) {
        result[key] = value
      }
    })

    if (data.ttlDvsnCd === '1') {
      const menuInfo = JSON.parse(data.rmrk)
      if (menuInfo.dvsn === 'M') {
        openMenuRecip(menuInfo)
      } else if (menuInfo.dvsn === 'C') {
        openCarte(menuInfo)
      } else if (menuInfo.dvsn === 'F') {
        openIngredients(menuInfo)
      } else if (menuInfo.dvsn === 'PM') {
        navigate(`/menucrte/phbtmenu?menuId=${menuInfo.menuId}`)
        closeModal()
        setSideMenuState({ isOpen: false })
      } else if (menuInfo.dvsn === 'PF') {
        navigate(`/menucrte/phbtfdingr?menuId=${menuInfo.menuId}`)
        closeModal()
        setSideMenuState({ isOpen: false })
      } else {
        alertModal('신메뉴제안은 PC에서 확인해주세요.')
      }
    } else if (data.ttlDvsnCd === '3') {
      alertModal('신메뉴제안은 PC에서 확인해주세요.')
    } else if (data.ttlDvsnCd === '4') {
      navigate(`/goods/prdcnetreq/${data.rmrk}`)
      closeModal()
      setSideMenuState({ isOpen: false })
    }
    notificationConfirm.mutate(data)
  }

  return (
    <>
      {data && data.length > 0 ? (
        Object.keys(list).map((key, index) => (
          <>
            <section className={index === 0 ? 'mt16 mb12' : 'mt16'} key={`group_${index}`}>
              <div className="mb12">
                <Text text={`${key} ${list[key][0].day}`} className="f-14 c-6 mx16" />
                <Line size="1" color="gray" />
              </div>
              <div className="wrapper">
                <StatusList className="no-last-border" data={list[key]} onClick={confirm} />
              </div>
            </section>
            <SplitBar className="w100p" key={`splitbar_${index}`} />
          </>
        ))
      ) : (
        <>
          <div className="flex-1 flex-align-center">
            <div className="flex-col flex-item-center">
              <span className="icon-message-gray"></span>
              <p style={{ marginTop: '20px' }}>조회된 데이터가 없습니다.</p>
            </div>
          </div>
        </>
      )}
    </>
  )
}
